"use client";

import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Bot, User } from "lucide-react";
import { cn, formatTime } from "@/lib/utils";
import type { Message as MessageType } from "@/types";

interface MessageProps {
  message: MessageType;
}

export function Message({ message }: MessageProps) {
  const isUser = message.role === "user";

  return (
    <div
      className={cn(
        "group flex gap-3 px-3 md:px-4 py-4 md:py-6 chat-message",
        isUser ? "bg-slate-900/30" : "bg-slate-950"
      )}
    >
      {/* Avatar */}
      <Avatar className="h-8 w-8 flex-shrink-0">
        {isUser ? (
          <>
            <AvatarImage src="" alt="User" />
            <AvatarFallback className="bg-slate-50 text-slate-900">
              <User className="h-4 w-4" />
            </AvatarFallback>
          </>
        ) : (
          <AvatarFallback className="bg-slate-800 text-slate-50">
            <Bot className="h-4 w-4" />
          </AvatarFallback>
        )}
      </Avatar>

      {/* Message Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-sm font-semibold">
            {isUser ? "Siz" : "AI Asistan"}
          </span>
          <span className="text-xs text-slate-400">
            {formatTime(message.timestamp)}
          </span>
        </div>

        <div className="prose prose-sm max-w-none dark:prose-invert">
          <p className="text-sm md:text-base leading-relaxed whitespace-pre-wrap m-0">
            {message.content}
          </p>
        </div>
      </div>
    </div>
  );
}